import React from "react";

const InputField = ({
  id,
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  icon: Icon,
  error,
  required,
  readOnly,
  autoComplete,
}) => {
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label htmlFor={id} className="text-[12.5px] font-medium text-text_secondary tracking-wide">
          {label}
          {required && <span className="text-danger ml-0.5"> *</span>}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <div className="absolute left-3.5 top-1/2 -translate-y-1/2 text-text_muted pointer-events-none">
            <Icon size={15} />
          </div>
        )}
        <input
          id={id}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          readOnly={readOnly}
          autoComplete={autoComplete}
          className={`w-full rounded border bg-surface_alt py-[11px] pr-4 text-sm text-text_primary placeholder:text-text_muted outline-none transition-all duration-150
            focus:bg-surface focus:ring-2 focus:ring-primary/[0.12] focus:border-primary/40
            ${readOnly ? "cursor-default select-none opacity-75" : ""}
            ${Icon ? "pl-[2.375rem]" : "pl-3.5"}
            ${
              error
                ? "border-danger/60 bg-danger_bg/40 focus:ring-danger/20 focus:border-danger"
                : "border-border hover:border-border_strong"
            }`}
        />
      </div>
      {error && (
        <p className="text-[11.5px] text-danger flex items-center gap-1">{error}</p>
      )}
    </div>
  );
};

export default InputField;
